module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"hammerjs","commonjs2":"hammerjs","amd":"hammerjs","root":"Hammer"}
// module id = 10
// module chunks = 0 1